import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}`, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cn_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export const fileUrl = (path) => `${BACKEND_URL}${path}`;

export async function uploadFile(file, purpose = "KYC_DOCUMENT") {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post(`/api/files/upload?purpose=${purpose}`, form);
  return data;
}

export const naira = (n) =>
  n == null ? "—" : `₦${Number(n).toLocaleString("en-NG", { maximumFractionDigits: 0 })}`;

export const dashboardPath = (role) =>
  ({
    MASTER_CLIENT: "/dashboard/master-client",
    REFERRAL_CLIENT: "/dashboard/referral-client",
    REFERRER: "/dashboard/referrer",
    WITNESS: "/dashboard/witness",
    SERVICE_PROVIDER: "/dashboard/service-provider",
    ADMIN: "/admin",
    SUPER_ADMIN: "/admin",
  }[role] || "/");

export const onboardingPath = (role) =>
  ({
    MASTER_CLIENT: "/onboarding/master-client",
    REFERRAL_CLIENT: "/onboarding/referral-client",
    REFERRER: "/onboarding/referrer",
    SERVICE_PROVIDER: "/onboarding/provider",
  }[role] || dashboardPath(role));

export const NG_STATES = [
  "Lagos", "FCT", "Rivers", "Oyo", "Enugu", "Kano", "Kaduna", "Ogun", "Anambra", "Delta", "Edo", "Abia",
];

export const ID_TYPES = ["NIN", "Drivers License", "International Passport", "Voters Card"];
